export default "__VITE_ASSET__D$KC5q8N__"